import React from 'react';
import { FadeIn } from './FadeIn';
import { ZapIcon } from 'lucide-react';
export function UniqueMethod() {
  return <section className="py-24 px-6 bg-navy-900 relative overflow-hidden" data-id="element-166">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-teal-600/5 blur-[150px] rounded-full pointer-events-none" data-id="element-167" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-168">
        <FadeIn data-id="element-169">
          <div className="text-center mb-10" data-id="element-170">
            <div className="inline-flex items-center justify-center p-3 bg-teal-500/10 rounded-2xl mb-6 border border-teal-500/20" data-id="element-171">
              <ZapIcon className="w-8 h-8 text-teal-400" data-id="element-172" />
            </div>
            <h2 className="font-serif text-3xl md:text-5xl font-bold mb-4" data-id="element-173">
              El Método C-P-C
            </h2>
            <p className="text-xl text-teal-400 font-medium tracking-wide" data-id="element-174">
              (Contraste-Presión-Calma)
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-175">
          <div className="bg-gradient-to-br from-navy-800 to-navy-900 p-8 md:p-12 rounded-3xl border border-teal-500/30 shadow-2xl shadow-teal-900/20" data-id="element-176">
            <p className="text-lg md:text-xl text-slate-200 leading-relaxed mb-6" data-id="element-177">
              Este protocolo utiliza la{' '}
              <strong className="text-white" data-id="element-178">neuromodulación periférica</strong>
              . En lugar de esperar a que un químico viaje por tu sangre,
              utilizamos señales físicas de frío y puntos de presión específicos
              en el nervio trigémino y occipital.
            </p>
            <div className="bg-teal-950/30 p-6 rounded-xl border-l-4 border-teal-500" data-id="element-179">
              <p className="text-slate-300 italic" data-id="element-180">
                "Al aplicar estas señales, 'engañamos' al cerebro para que
                cierre la puerta al dolor y fuerce una vasoconstricción
                inmediata. Es como aplicar un freno de mano biológico a la
                crisis migrañosa."
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}